export default __webpack_public_path__ + "assets/03_AddLayers.png";